import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { LegacySharedBudget } from './legacy-shared-budget';

const LegacySharedBudgetWithCustomValidation = ({
  campaignId, validationProps, updateValidation, ...restProps
}) => {
  const { data } = validationProps;
  const i18n = useContext(I18nContext);
  const activity = useContext(ActivityContext);

  const onChange = useCallback((newData, newIsValid) => {
    updateValidation(newIsValid ? [] : [i18n.getString(_TL_('Legacy Budget has validation errors'))], { Budget: newData });
    if (activity) {
      // signal activity to parent
      activity.signal(`onLegacySharedBudgetChange - ${JSON.stringify(newData)} - isValid: ${newIsValid}}`);
    }
  }, [i18n, updateValidation, activity]);

  return (
    <LegacySharedBudget
      level="campaign"
      campaignId={campaignId}
      onChange={onChange}
      budget={data.Budget}
      i18n={i18n}
      {...restProps}
    />
  );
};

LegacySharedBudgetWithCustomValidation.propTypes = {
  campaignId: PropTypes.string.isRequired,
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      Budget: PropTypes.shape({
        Amount: PropTypes.number,
      }),
    }),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
};

export const ValidatedLegacySharedBudget = withCustomValidation(LegacySharedBudgetWithCustomValidation);

